import { Action } from 'redux'
import {
  GET_PAYMENT_METHOD_FAILURE,
  GET_PAYMENT_METHOD_SUCCESS,
  UPDATE_PAYMENT_METHOD_STATE
} from 'redux/actionTypes'
import { AnyObject } from 'typings/custom'

interface PaymentMethodAction extends Action {
  payload?: AnyObject
  props?: AnyObject
}
export interface PaymentMethodProps {
  dataList: Array<AnyObject>
  isDataLoading: boolean
  isResponseFail: boolean
}

export const initState: PaymentMethodProps = {
  dataList: [],
  isDataLoading: true,
  isResponseFail: false
}

const PaymentMethod = (
  // eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
  state = initState,
  action: PaymentMethodAction
): PaymentMethodProps => {
  const { type, payload } = action
  switch (type) {
    case GET_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        ...payload,
        isResponseFail: false,
        isDataLoading: false
      }
    case GET_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        ...payload,
        isResponseFail: true,
        isDataLoading: false
      }
    case UPDATE_PAYMENT_METHOD_STATE:
      return {
        ...state,
        ...payload
      }
    default:
      return state
  }
}

export default PaymentMethod
